// 课程中心--课程商品
export const courseTypeData = [
  {
    value: 1,
    label: '素质课程',
    children: [
      {
        value: 11,
        label: '艺术',
        children: [],
        loading: false
      },
      {
        value: 12,
        label: '科技',
        children: [],
        loading: false
      },
      {
        value: 13,
        label: '体育',
        children: [],
        loading: false
      },
      {
        value: 14,
        label: '美术',
        children: [],
        loading: false
      },
      {
        value: 15,
        label: '综合实践',
        children: [],
        loading: false
      }
    ],
    loading: false
  },
  {
    value: 2,
    label: '托管',
    children: [
      {
        value: 21,
        label: '早托',
        children: [],
        loading: false
      },
      {
        value: 22,
        label: '午托',
        children: [],
        loading: false
      },
      {
        value: 23,
        label: '晚托',
        children: [],
        loading: false
      },
      {
        value: 24,
        label: '全托',
        children: [],
        loading: false
      }
    ],
    loading: false
  }
]
